// extracted by mini-css-extract-plugin
module.exports = {"submenu":"ProfileSubmenu_submenu__1d75u","submenuSticky":"ProfileSubmenu_submenuSticky__2shvW","item":"ProfileSubmenu_item__g0rLA","isActive":"ProfileSubmenu_isActive__haPD3"};